import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";
import { useMemo } from "react";

const REFERRERS_BASE = "/referrers";

const fetchReferrersAPI = () => API.get(`${REFERRERS_BASE}`);

const addNewReferrerAPI = (data) =>
  API.post(`${REFERRERS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateReferrerAPI = (id, data) =>
  API.patch(`${REFERRERS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const getActiveReferrersAPI = () =>
  API.get(`${REFERRERS_BASE}?active=true&orderby=ReferrerName`);

const baseService = createApplicationService({
  name: "referrers",
  apiFetchFn: fetchReferrersAPI,
  apiAddFn: addNewReferrerAPI,
  apiUpdateFn: updateReferrerAPI,
});

const referrerReducer = baseService.reducer;
const getReferrers = baseService.getData;
const addReferrer = baseService.addData;
const updateReferrer = baseService.updateData;
const useReferrers = baseService.useData;

const useActiveReferrers = () => {
  const { data, loading } = useReferrers();
  const activeReferrers = useMemo(() => {
    return data
      .filter((r) => r.active)
      .sort((a, b) => {
        const nameA = (a.referrerName || "").toLowerCase();
        const nameB = (b.referrerName || "").toLowerCase();
        return nameA.localeCompare(nameB);
      });
  }, [data]);
  return { data: activeReferrers, loading };
};

export {
  referrerReducer,
  getReferrers,
  addReferrer,
  updateReferrer,
  useReferrers,
  useActiveReferrers,
};
